import profileApi from "../../api/profile"
import utilsApi from "../../api/utils"

// general state for the eCommerce
const state = {
  profile: {},
  fetched: false,
  error: false,
  dataShape: [],
  extraInfo: {},
}

const getters = {
  profile: state => state.profile,
  profile_fetched: state => state.fetched,
  profileError: state => state.error,
  profile_dataShape: state => state.dataShape,
  profile_extraInfo: state => state.extraInfo,
}

const actions = {
  async PAUSE_PLAN({ commit }, days) {
    console.log("ESTE ES EL DAYS DE PAUUS ", days)
    let apiResponse = await profileApi.pausePlan(days)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PAUSE_PLAN_SUCC", apiResponse)
      return true
    } else {
      commit("PROFILES_ERROR")
      return false
    }
  },
  async DELETE_PROFILE({ commit }) {
    let apiResponse = await profileApi.deleteProfile()
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("NEW_PROFILE_SUCCES_profile", apiResponse)

      // account module
      commit("CHANGE_K_SUCCES", apiResponse)
      return true
    } else {
      commit("PROFILES_ERROR")
      return false
    }
  },
  async DUPLICATE_PROFILE({ commit }) {
    let apiResponse = await profileApi.duplicateProfile()
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("NEW_PROFILE_SUCCES_profile", apiResponse)

      commit("CHANGE_K_SUCCES", apiResponse)
      // account module
      commit("NEW_PROFILE_SUCCES_account", apiResponse)
      return true
    } else {
      commit("PROFILES_ERROR")
      return false
    }
  },
  async CREATE_profile({ commit }, profile) {
    let apiResponse = await utilsApi.createObject("profile", profile)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PROFILES_SETTING", apiResponse)
    } else {
      commit("PROFILES_ERROR")
    }
  },
  async SAVE_profile({ commit }, profile) {
    let apiResponse = await utilsApi.saveObject("profile", profile)
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PROFILES_SETTING", apiResponse)
      commit("CHANGE_K_SUCCES", apiResponse)
      return true
    } else {
      commit("PROFILES_ERROR")
      return false
    }
  },
  async FETCH_profile({ commit }) {
    let apiResponse = await utilsApi.getObjects("profile")
    console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PROFILES_SETTING", apiResponse)
      return true
    } else {
      commit("PROFILES_ERROR")
      return false
    }
  },
  CLEAN_profile({ commit }) {
    commit("CHANGE_K_SUCCES_PROFILE", { profile: {} })
    return true
  },
}
const mutations = {
  PAUSE_PLAN_SUCC: (state, { success }) => {
    state.error = !success
  },
  NEW_PROFILE_SUCCES_profile: (state, { profile }) => {
    state.profile = profile
  },
  CHANGE_K_SUCCES_PROFILE: (state, { profile }) => {
    state.profile = profile
  },
  PROFILES_SETTING: (state, { profile, dataShape, extraInfo }) => {
    console.log(state)
    state.profile = profile
    state.dataShape = dataShape
    state.extraInfo = extraInfo
    state.fetched = true
    state.error = false
  },
  PROFILES_ERROR: state => {
    state.profile = null
    state.fetched = true
    state.dataShape = []
    state.error = true
  },
  ERROR: state => {
    state.fetched = true
    state.error = true
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
